export default "__VITE_ASSET__8c0a2aea__"